// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { ProjectRole } from "./ProjectRole";
import {
  ProjectRoleFromJSON,
  ProjectRoleFromJSONTyped,
  ProjectRoleToJSON,
  ProjectRoleToJSONTyped,
} from "./ProjectRole";

/**
 *
 * @export
 * @interface ProjectUser
 */
export interface ProjectUser {
  /**
   *
   */
  user: User;
  /**
   *
   */
  role: ProjectRole;
}

/**
 * Check if a given object implements the ProjectUser interface.
 */
export function instanceOfProjectUser(value: object): value is ProjectUser {
  if (!("user" in value) || value["user"] === undefined) return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  return true;
}

export function ProjectUserFromJSON(json: any): ProjectUser {
  return ProjectUserFromJSONTyped(json, false);
}

export function ProjectUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUser {
  if (json == null) {
    return json;
  }
  return {
    user: UserFromJSON(json["user"]),
    role: ProjectRoleFromJSON(json["role"]),
  };
}

export function ProjectUserToJSON(json: any): ProjectUser {
  return ProjectUserToJSONTyped(json, false);
}

export function ProjectUserToJSONTyped(
  value?: ProjectUser | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    user: UserToJSON(value["user"]),
    role: ProjectRoleToJSON(value["role"]),
  };
}
